import React from 'react';

import cn from 'classnames';
import PropTypes from 'prop-types';
import { IoSearch } from 'react-icons/io5';

import ViewImage from 'modules/common/Img/components/ViewImage';

function Addons({ form, setForm }) {
  const existsIndex = (row) =>
    form?.selected_addons?.findIndex((item) => item?.uuid === row?.uuid);

  const handleOnChange = (row, index) => () => {
    if (index > -1) {
      setForm((prevState) => ({
        ...prevState,
        selected_addons: form?.selected_addons?.filter(
          (item, key) => key !== index
        ),
      }));

      return;
    }

    setForm((prevState) => ({
      ...prevState,
      selected_addons: [...form?.selected_addons, row],
    }));
  };

  return (
    <div className="space-y-3">
      <div>
        <div className="font-semibold">Add-ons</div>
        <div className="text-sm text-gray-500">
          Choose a add-ons of this product below
        </div>
      </div>

      <div className="flex flex-col gap-2">
        {form?.addons?.length > 0 ? (
          form?.addons?.map((item, key) => (
            <div
              // eslint-disable-next-line react/no-array-index-key
              key={key}
            >
              <div className="text-xs mb-1">{item?.name}</div>
              <div className="grid grid-cols-2 gap-2">
                {item?.addons?.map((subItem) => (
                  <div
                    // eslint-disable-next-line react/no-array-index-key
                    key={key}
                    className={cn(
                      'flex border text-black rounded cursor-pointer h-16',
                      {
                        'border-primary-500 !text-primary-500 bg-primary-50':
                          existsIndex(subItem) > -1,
                      }
                    )}
                    role="presentation"
                    onClick={handleOnChange(subItem, existsIndex(subItem))}
                  >
                    <div className="w-16 border-r">
                      <ViewImage
                        src={subItem?.photo_url}
                        className="w-16 object-cover rounded-l-sm"
                        heightClassName="h-full"
                        containerClassName="h-full"
                        hoverLabel={<IoSearch className="h-5 w-5" />}
                        stopPropagation
                      />
                    </div>

                    <div className="space-y-0.5 p-2 px-3 flex-1">
                      <div className="font-medium capitalize text-xs">
                        {subItem?.name}
                      </div>
                      <div
                        className={cn('text-xxs text-gray-500', {
                          '!text-primary-500': existsIndex(subItem) > -1,
                        })}
                      >
                        {subItem?.price_human}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))
        ) : (
          <div className="text-center text-gray-400 text-xs col-span-3 py-5">
            <i>There are no add-ons for this product.</i>
          </div>
        )}
      </div>
    </div>
  );
}

Addons.defaultProps = {
  form: {},
  setForm: () => {},
};

Addons.propTypes = {
  form: PropTypes.instanceOf(Object),
  setForm: PropTypes.instanceOf(Function),
};

export default Addons;
